import React from 'react';
import Config from '../util/config';

export interface Props {
    nights: number[];
    selected: number;
    onChange: (night: number) => void;
}

const NightSelect = (props: Props) => {
    let nightText = '';
    if(props.nights.length == 0) {
        nightText = '2 Nights'
    }else {
        nightText = Config.get('defaultNightOption', 'Select nights')
    }

    const options: JSX.Element[] = props.nights.map((value: number) => {
        return <option key={value} selected={value == 2}  value={value}>
            {value + ' Night' + (value !== 1 ? 's' : '')}
        </option>
    });

    options.unshift(
        <option key={0} value={0}>
            { nightText }
        </option>
    );

    return <select
        className="night-selector"
        value={props.selected}
        onChange={(evt) => props.onChange(parseInt(evt.target.value))}
    >
        {options}
    </select>
}

export default NightSelect;

